import Color from "color";

export const red = "#EB5757";
export const blue = "#206cd1";
export const strongBlue = "#1d59ab";
export const dodgerBlue = "#2681FA";
export const darkBlue = "#091e3b";
export const darkGreen = "#219653";
export const green = "#57CA81";
export const turmeric = "#A9B531";
export const darkOrange = "#F2994A";
export const orange = "#FF9435";
export const yellow = "#E1B827";
export const lightYellow = "#fffaec";
export const highlightYellow = "#ffffcc";
export const marine = "#004F9E";
export const cyan = "#00ACC1";
export const lightCyan = "#e6f7ff";
export const concrete = "#78909C";
export const pink = "#FFC0CB";
export const turquoise = "#247893";

export const lightBlue = "#5FD5F9";
export const lightPurple = "#f2f1fa";
export const winterMist = "#f2f2f2";
export const whiteSmoke = "#f5f5f5";
export const purple = "#8C198C";
export const lightRed = "#FFE3E3";

export const info = "#409BF6";
export const success = "#219653";
export const warning = "#F2994A";
export const error = "#EB5757";

export const black = "#000";
export const nearBlack = "#111";
export const darkGray = "#333";
export const midGray = "#555";
export const mediumLightGray = "#bbb";
export const lightMidGray = "#ddd";
export const gray = "#777";
export const silver = "#999";
export const lightSilver = "#aaa";
export const moonGray = "#ccc";
export const lightGray = "#eee";
export const nearWhite = "#f4f4f4";
export const lightWhite = "#fafafa";
export const white = "#fff";
export const navy = "#5fd5f9";
export const gold = "#D4AF37";

export const STATUS_COLOR = {
  inactive: "#C4C4C4",
  unassigned: "#C4C4C4",
  pending: warning,
  configured: navy,
  provisioned: info,
  installing: info,
  provisioning: info,
  active: success,
  running: success,
  success,
  warning,
  error,
  deleting: error,
  deleted: error,
};

export const BAR_CHART_COLORS = [
  "#4432F5",
  "#5FD5F9",
  "#AF26FA",
  "#D4AF37",
  "#003366",
  "#42d4f4",
  "#f032e6",
  "#bfef45",
  "#daa520",
  "#469990",
  "#8b0000",
  "#9A6324",
  "#8a2be2",
  "#00ced1",
  "#66cdaa",
  "#808000",
  "#f7347a",
  "#000075",
  "#ff4040",
].map((color) => Color(color).lighten(0.3).hex());

export const COREHOURS_CHART_COLOR = Color("#4432F5").lighten(0.5).hex();
